import React from 'react'
import GreyBig from '../GreyBig'
import { numberAddCommas } from '../../../../../../servos/formValidations'
import { financialYear, currentFinancialYear} from '../../../lib/financialYear'

const employerTypesMap = {
  asx200: 'ASX 200 company',
  other: 'Other',
  government: 'Government',
}

const frequencyMap = {
  yearly: 'annually',
  fortnightly: 'fortnightly',
  monthly: 'monthly',
  weekly: 'weekly',
}

class MainIncome extends React.Component {
  render() {
    const { income, incomeEmployerType } = this.props
    const {
      incomeType,
      amount,
      amountPreviousYear,
      frequency,
      frequencyPreviousYear,
      additionalPaygIncomes,
    } = income

    const {
      bonus,
      overtime,
      commission,
      allowance
    } = additionalPaygIncomes

    if (incomeType === 'Incomes::Payg') {
      return(
        <div>
          <GreyBig size='3' grey='Source of Income' big='PAYG' />
          <GreyBig size='3' grey='Employer' big={ employerTypesMap[incomeEmployerType] } />
          <GreyBig size='3' grey='Base salary' big={ `${'$' + numberAddCommas(amount)} ${frequencyMap[frequency]}` } />

          { bonus &&
          <div className="mb-3">
            <div className="grey">Bonus</div>
            <div className="big">
              {'$' + numberAddCommas(bonus.amount)} {frequencyMap[bonus.frequency]} last year
            </div>
            <div className="big">
              {'$' + numberAddCommas(bonus.amountPreviousYear)} {frequencyMap[bonus.frequencyPreviousYear]} the year prior
            </div>
          </div>
          }

          { overtime &&
          <div className="mb-3">
            <div className="grey">Overtime</div>
            <div className="big">
              { '$' + numberAddCommas(overtime.amount) } { frequencyMap[overtime.frequency] }
              {
                (overtime.periodMonths || overtime.periodYears) &&
                  <span>
                    <span> for </span>
                    {overtime.periodYears &&
                      `${overtime.periodYears} year${ overtime.periodYears > 1 ? 's' : ''}`
                    }

                    { (overtime.periodMonths && overtime.periodYears) &&
                      <span> and </span>
                    }
                    {overtime.periodMonths &&
                    `${overtime.periodMonths} month${ overtime.periodMonths > 1 ? 's' : ''}`
                    }
                  </span>
              }
            </div>
          </div>
          }

          { commission &&
          <div className="mb-3">
            <div className="grey">Commission</div>
            <div className="big">
              {'$' + numberAddCommas(commission.amount)} {frequencyMap[commission.frequency]} in FY {currentFinancialYear().lastYear}
            </div>
            <div className="big">
              {'$' + numberAddCommas(commission.amountPreviousYear)} {frequencyMap[commission.frequencyPreviousYear]} in FY {currentFinancialYear().yearBeforeLast}
            </div>
          </div>
          }

          { allowance &&
          <div className="mb-3">
            <div className="grey">Untaxed allowance</div>
            <div className="big">
              {'$' + numberAddCommas(allowance.amount)} {frequencyMap[allowance.frequency]}
            </div>
          </div>
          }

          <hr />
        </div>
      )
    } else {
      return(
        <div>
          <GreyBig size='3' grey='Source of Income' big='Self employment' />
          <GreyBig size='3' grey={`Net profit in FY ${financialYear().lastYear}`} big={ `${'$' + numberAddCommas(amount)} ${frequencyMap[frequency]}` } />
          <GreyBig size='3' grey={`Net profit in FY ${financialYear().yearBeforeLast}`} big={ `${'$' + numberAddCommas(amountPreviousYear)} ${frequencyMap[frequencyPreviousYear]}` } />
          <hr />
        </div>
      )
    }
  }
}

export default MainIncome;
